import "./banner.scss"
import React from "react";

const Banner = ({title, image}) => {
    return (
        <div className="banner">
        <div className="images">
            <img
            src={ image? image: "/images/cover_user.jpg"}
            alt="Cover"
            className="cover"
            />
            <h1>{title? title: "Untitled"}</h1>
        </div>
        </div>
    )
}

export default React.memo(Banner);